/* Publish by EComposer at 2026-10-21 02:02:17*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ireqlg7myxt"]=  window.__ectimmers["ecom-ireqlg7myxt"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ireqlg7myxt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ireqlg7myxt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53tgtm72uf7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53tgtm72uf7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wk1u742nxii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wk1u742nxii', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23tm8g7vm2w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23tm8g7vm2w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8y249y0hj29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8y249y0hj29', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-31m8mutlv2x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-31m8mutlv2x', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}